export const ru = {
    contains: 'содержит',
    'day-placeholder': 'дд',
    'incorrect-date': 'Некорректная дата',
    'month-placeholder': 'мм',
    'not-contains': 'не содержит',
    'year-placeholder': 'гггг'
};
